import React, { useEffect, useState } from 'react';
import {
  Dialog,
  Input,
  Button,
  Select,
  Message,
  Card,
  Table,
  NumberPicker,
  Checkbox,
  DatePicker,
  Radio,
} from '@alifd/next';
import { Form } from 'antd';
import axios from 'axios';
import moment from 'moment';
import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const RadioGroup = Radio.Group;
const { RangePicker } = DatePicker;
const Option = Select.Option;
const RepairPlanList = () => {
  const [LongRepairForm] = Form.useForm();
  const [LongRepairRecordForm] = Form.useForm();
  const communityDevice = client.service('communityDevice');
  const annualFixBudget = client.service('annualFixBudget');
  const [communityDeviceDialog, setCommunityDeviceDialog] = useState(false);
  const [communityDeviceArr, setCommunityDeviceArr] = useState([]);
  const [communityDeviceUpdate, setCommunityDeviceUpdate] = useState({});
  const [communityDeviceStatus, setCommunityDeviceStatus] = useState('insert');
  const [isUpdate, setIsUpdate] = useState(false);
  const [annualFixBudgetArr, setAnnualFixBudgetArr] = useState([]);
  const [annualFixBudgetDialog, setAnnualFixBudgetDialog] = useState(false);
  const [
    annualFixBudgetRecordDialog,
    setAnnualFixBudgetRecordDialog,
  ] = useState(false);

  useEffect(() => {
    communityDevice
      .find({ query: {} })
      .then((result) => {
        setCommunityDeviceArr(result.data);
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .post(
        '/ezcon/api/postMongoAggregate',
        {
          aggregate: [
            {
              $addFields: {
                deviceId: { $toObjectId: '$deviceId' },
              },
            },
            {
              $lookup: {
                from: 'communityDevice',
                localField: 'deviceId',
                foreignField: '_id',
                as: 'communityDevice',
              },
            },
            {
              $match: {
                isLong: true,
              },
            },
          ],
          service: 'annualFixBudget',
        },
        {
          headers: {
            authorization: localStorage.getItem('feathers-jwt'),
          },
        }
      )
      .then((result) => {
        setAnnualFixBudgetArr(result.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [isUpdate, communityDevice]);

  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 4,
      },
    },
    wrapperCol: {
      xs: {
        span: 24,
      },
      sm: {
        span: 20,
      },
    },
  };
  const formItemLayoutWithOutLabel = {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0,
      },
      sm: {
        span: 20,
        offset: 4,
      },
    },
  };

  const onFinish = (value) => {
    const newDeviceObject = {
      deviceId: value.deviceId,
      repairFrequency: `${value.repairNum}${value.repairUnit}`,
      repairWeek: value.repairWeek,
      repairRecords: [],
      repairExpenses: parseInt(value.repairExpenses, 10),
      repairBalance: parseInt(value.repairExpenses, 10),
      repairStartYear: moment(value.repairStartYear[0]).valueOf(),
      repairEndYear: moment(value.repairStartYear[1]).valueOf(),
      isLong: true,
    };
    if (communityDeviceStatus === 'insert') {
      annualFixBudget
        .create(newDeviceObject)
        .then(() => {
          Message.success('新增成功');
          setCommunityDeviceDialog(false);
          setIsUpdate((pre) => !pre);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      annualFixBudget
        .patch(communityDeviceUpdate._id, newDeviceObject)
        .then(() => {
          Message.success('修改成功');
          setCommunityDeviceDialog(false);
          setIsUpdate((pre) => !pre);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const onFinishRecord = (value) => {
    const newRecordObject = [
      ...communityDeviceUpdate.repairRecords,
      {
        ...value,
        createdTime: moment().valueOf(),
      },
    ];
    annualFixBudget
      .patch(communityDeviceUpdate._id, {
        repairRecords: newRecordObject,
        repairBalance: parseInt(
          communityDeviceUpdate.repairBalance - value.repairRecordMoney,
          10
        ),
      })
      .then(() => {
        Message.success('新增修繕記錄成功');
        setIsUpdate((pre) => !pre);
        setAnnualFixBudgetRecordDialog(false);
        annualFixBudget
          .find({ query: { _id: communityDeviceUpdate._id } })
          .then((result) => {
            setCommunityDeviceUpdate(result.data[0]);
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <Button
        onClick={() => {
          setCommunityDeviceDialog(true);
          setCommunityDeviceStatus('insert');
        }}
      >
        新增
      </Button>

      <Dialog
        hasMask
        className={styles.dialog}
        visible={communityDeviceDialog}
        onOk={() => {
          LongRepairForm.submit();
        }}
        onCancel={() => {
          setCommunityDeviceDialog(false);
        }}
        onClose={() => {
          setCommunityDeviceDialog(false);
        }}
      >
        <h1>
          {communityDeviceStatus === 'insert' ? '新增' : '修改'}年度修繕預算
        </h1>

        <Form
          form={LongRepairForm}
          name="dynamic_form_item"
          onFinish={onFinish}
          {...formItemLayoutWithOutLabel}
          initialValues={
            communityDeviceUpdate?.deviceId
              ? {
                  deviceId: communityDeviceUpdate.deviceId,
                  repairUnit: communityDeviceUpdate.repairFrequency.split(
                    ''
                  )[1],
                  repairNum: communityDeviceUpdate.repairFrequency.split('')[0],
                  repairWeek: communityDeviceUpdate.repairWeek,
                  repairExpenses: communityDeviceUpdate.repairExpenses,
                  repairStartYear: [
                    moment(communityDeviceUpdate.repairStartYear),
                    moment(communityDeviceUpdate.repairEndYear),
                  ],
                }
              : { repairNum: 0 }
          }
        >
          <Form.Item
            {...formItemLayout}
            rules={[
              {
                required: true,
                message: '請選擇設備名稱',
              },
            ]}
            label="設備名稱"
            name="deviceId"
          >
            <Select
              className={styles.options}
              placeholder="請選擇設備名稱"
              aria-label="name is"
            >
              {communityDeviceArr.map((item) => (
                <Option value={item._id}>{item.deviceName}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="修繕週期"
            required={[{ required: true, message: '請選擇填選' }]}
            {...formItemLayout}
          >
            <div className={styles.workingBox}>
              每
              <Form.Item
                name="repairNum"
                noStyle
                rules={[
                  {
                    required: true,
                    message: '請選擇天數',
                  },
                ]}
              >
                <NumberPicker min={0} />
              </Form.Item>
              <Form.Item
                noStyle
                name="repairUnit"
                rules={[
                  {
                    required: true,
                    message: '請選擇時段',
                  },
                ]}
              >
                <Select hasClear placeholder="請選擇時段" aria-label="name is">
                  <Option value="週">週</Option>
                  <Option value="月">月</Option>
                  <Option value="季">季</Option>
                  <Option value="年">年</Option>
                </Select>
              </Form.Item>
            </div>
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            rules={[
              {
                required: true,
                message: '請勾選修繕週期',
              },
            ]}
            label="修繕週期"
            name="repairWeek"
          >
            <Checkbox.Group>
              <Checkbox value="一">星期一</Checkbox>
              <Checkbox value="二">星期二</Checkbox>
              <Checkbox value="三">星期三</Checkbox>
              <Checkbox value="四">星期四</Checkbox>
              <Checkbox value="五">星期五</Checkbox>
              <Checkbox value="六">星期六</Checkbox>
              <Checkbox value="日">星期日</Checkbox>
            </Checkbox.Group>
          </Form.Item>
          <Form.Item
            label="修繕年度"
            name="repairStartYear"
            required={[{ required: true, message: '請選擇修繕年度區間' }]}
            {...formItemLayout}
          >
            <RangePicker type="year" />
          </Form.Item>
          <Form.Item
            {...formItemLayout}
            rules={[
              {
                required: true,
                message: '請選擇輸入年度維修預算',
              },
            ]}
            label="總預算"
            name="repairExpenses"
          >
            <Input innerAfter="元" />
          </Form.Item>
        </Form>
      </Dialog>
      {/* 查看維修記錄 */}

      <Dialog
        hasMask
        className={styles.dialog}
        visible={annualFixBudgetDialog}
        onOk={() => {
          setAnnualFixBudgetDialog(false);
        }}
        onCancel={() => {
          setAnnualFixBudgetDialog(false);
        }}
        onClose={() => {
          setAnnualFixBudgetDialog(false);
        }}
      >
        <h1>查詢年度修繕記錄</h1>
        <Button
          type="normal"
          onClick={() => setAnnualFixBudgetRecordDialog(true)}
          style={{ marginBottom: '20px' }}
        >
          新增修繕記錄
        </Button>
        <Table dataSource={communityDeviceUpdate.repairRecords}>
          <Table.Column
            dataIndex="createdTime"
            title="維修時間"
            cell={(value) => moment(value).format('YYYY-MM-DD')}
          />
          <Table.Column dataIndex="repairRecordStatus" title="修繕狀態" />
          <Table.Column dataIndex="repairRecordText" title="修繕記錄" />
          <Table.Column dataIndex="repairRecordMoney" title="修繕金額" />
          <Table.Column dataIndex="repairRecordPerson" title="修繕人員" />
        </Table>
      </Dialog>

      {/* 新增編輯維修記錄 */}
      <Dialog
        name="dynamic_form_item"
        hasMask
        className={styles.dialog}
        visible={annualFixBudgetRecordDialog}
        onOk={() => {
          LongRepairRecordForm.submit();
        }}
        onCancel={() => {
          setAnnualFixBudgetRecordDialog(false);
        }}
        onClose={() => {
          setAnnualFixBudgetRecordDialog(false);
        }}
      >
        <h1>新增修繕記錄</h1>
        <Form
          form={LongRepairRecordForm}
          onFinish={onFinishRecord}
          {...formItemLayoutWithOutLabel}
        >
          <Form.Item
            label="設備狀態"
            name="repairRecordStatus"
            rules={[
              {
                required: true,
                message: '請選擇維修狀態',
              },
            ]}
            {...formItemLayout}
          >
            <RadioGroup aria-labelledby="groupId">
              <Radio value="處理中">處理中</Radio>
              <Radio value="已處理">已處理</Radio>
            </RadioGroup>
          </Form.Item>
          <Form.Item
            label="修繕記錄"
            name="repairRecordText"
            rules={[
              {
                required: false,
                message: '請輸入修繕記錄',
              },
            ]}
            {...formItemLayout}
          >
            <Input.TextArea />
          </Form.Item>
          <Form.Item
            label="修繕金額"
            name="repairRecordMoney"
            rules={[
              {
                required: true,
                message: '請輸入修繕單次費用',
              },
            ]}
            {...formItemLayout}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="修繕人員"
            name="repairRecordPerson"
            rules={[
              {
                required: true,
                message: '請輸入修繕人員',
              },
            ]}
            {...formItemLayout}
          >
            <Input />
          </Form.Item>
        </Form>
      </Dialog>

      <br />
      <br />
      <Card free>
        <Card.Content>
          <Table dataSource={annualFixBudgetArr}>
            <Table.Column
              title="設備名稱"
              width={200}
              cell={(_value, _index, record) => {
                return <div>{record.communityDevice[0].deviceName}</div>;
              }}
            />
            <Table.Column
              title="設備編號"
              width={100}
              cell={(_value, _index, record) => {
                return <div>{record.communityDevice[0].deviceNumber}</div>;
              }}
            />

            <Table.Column
              title="設備修繕週期"
              dataIndex="repairFrequency"
              width={200}
              cell={(value, _index, record) => {
                const check = value.split('');
                return (
                  <>
                    每{check[0]}
                    {check[1]}
                    {record.repairWeek.join(',')}
                  </>
                );
              }}
            />
            <Table.Column
              title="維護廠商"
              width={100}
              cell={(_value, _index, record) => {
                return (
                  <div>{record.communityDevice[0].deviceVendor[0].name}</div>
                );
              }}
            />
            <Table.Column
              title="維修預算"
              width={100}
              dataIndex="repairExpenses"
              cell={(value) => `${value}元`}
            />
            <Table.Column
              title="目前剩餘預算"
              width={100}
              dataIndex="repairBalance"
              cell={(value) => `${value}元`}
            />
            <Table.Column
              title="操作"
              width={100}
              cell={(_value, _index, record) => {
                if (record.repairRecords.length === 0) {
                  return (
                    <div className={styles.btnGroup}>
                      <Button
                        type="primary"
                        onClick={() => {
                          setCommunityDeviceUpdate(record);
                          setAnnualFixBudgetDialog(true);
                        }}
                      >
                        查看年度修繕記錄
                      </Button>

                      <Button
                        type="normal"
                        onClick={() => {
                          setCommunityDeviceStatus('update');
                          setCommunityDeviceUpdate(record);
                          setCommunityDeviceDialog(true);
                        }}
                      >
                        編輯
                      </Button>
                      <Button
                        type="primary"
                        onClick={() => {
                          annualFixBudget
                            .remove(record._id)
                            .then(() => {
                              Message.success('刪除成功');
                              setIsUpdate((pre) => !pre);
                            })
                            .catch((error) => console.log(error));
                        }}
                        warning
                      >
                        刪除
                      </Button>
                    </div>
                  );
                } else {
                  return (
                    <div className={styles.btnGroup}>
                      <Button
                        type="primary"
                        onClick={() => {
                          setCommunityDeviceUpdate(record);
                          setAnnualFixBudgetDialog(true);
                        }}
                      >
                        查看年度修繕記錄
                      </Button>
                    </div>
                  );
                }
              }}
            />
          </Table>
        </Card.Content>
      </Card>
    </>
  );
};

export default RepairPlanList;
